import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const currentTheme = localStorage.getItem('theme');

type SettingsState = {
    theme: 'light' | 'dark';
    permissionList: string[] | undefined;
};

const initialState: SettingsState = {
    theme: !currentTheme || currentTheme === 'light' ? 'light' : 'dark',
    permissionList: undefined,
};

export const SettingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setTheme: (
            state: SettingsState,
            action: PayloadAction<'light' | 'dark'>,
        ) => {
            state.theme = action.payload;
            localStorage.setItem('theme', action.payload);
        },
        setPermissionList: (
            state: SettingsState,
            action: PayloadAction<string[] | undefined>,
        ) => {
            state.permissionList = action.payload || [];
        },
    },
});

export const { setTheme, setPermissionList } = SettingsSlice.actions;

export default SettingsSlice.reducer;

export const themeModeSelector = (state: RootState) => state.settings.theme;
export const permissionListSelector = (state: RootState) =>
    state.settings.permissionList;
